<ng-container>
    <div class="overlay-warp">
        <div class="itemx" *ngFor="let month of options$()">
            <div class="item-list">
                <div class="choose" [ngClass]="{'selected': selected$().includes(month)}" (click)="toggleMonth(month)">
                    <div class="inner-selected">
                        <img src="/assets/images/auto-fill/vi.svg">
                    </div>
                </div>
                <p *ngIf="month !== notTransferred">{{ month | quePayrollMonth }}</p>
                <p *ngIf="month === notTransferred" translate>column.approvals.payrollMonthNotTransferred</p>
            </div>
        </div>
    </div>
</ng-container>
